/** @format */

enum TYPES {
	SET_PAYMENT_INTENT = 'SET_PAYMENT_INTENT',
	SET_ERROR_FOR_PAYMENT_INTENT = 'SET_ERROR_FOR_PAYMENT_INTENT',
}

export default TYPES;
